
export default (state = [], action)=>{
    switch(action.type){
        case "set-sites":
            return action.sites
        default:
            return state;
    }
}
